var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.7817mm",
    height: "10.308mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 218.54 208.94",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993512258608"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    y: 174.29,
    width: 19.84,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993512255968"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 46.28,
    y: 174.29,
    width: 127.9,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993512256976"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    y: 144.15,
    width: 218.54,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993512256880"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    y: 204.43,
    width: 218.54,
    height: 4.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M170.91 123.34l-123.34 0 0 -123.34 123.34 0 0 123.34zm-118.79 -4.56l114.12 0 0 -114.28 -114.12 0 0 114.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M79.05 46.6c-8.41,0 -15.23,-6.82 -15.23,-15.23 0,-8.41 6.82,-15.23 15.23,-15.23 8.41,0 15.23,6.82 15.23,15.23 0,0.02 0,0.04 0,0.05 0,0 0,0 0,0 0,8.38 -6.8,15.18 -15.18,15.18 -0.02,0 -0.04,0 -0.05,0l0 -0zm0 -25.85c-5.92,0 -10.72,4.8 -10.72,10.73 0,5.92 4.8,10.73 10.73,10.73 5.92,0 10.73,-4.8 10.73,-10.73 0,-5.92 -4.8,-10.73 -10.73,-10.73l-0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M138.04 46.6c-8.41,0 -15.23,-6.82 -15.23,-15.23 0,-8.41 6.82,-15.23 15.23,-15.23 8.41,0 15.23,6.82 15.23,15.23 0,0.02 0,0.04 0,0.05 0,0 0,0 0,0 0,8.38 -6.8,15.18 -15.18,15.18 -0.02,0 -0.04,0 -0.05,0l0 -0zm0 -25.85c-5.92,0 -10.73,4.8 -10.73,10.73 0,5.92 4.8,10.73 10.73,10.73 5.92,0 10.73,-4.8 10.73,-10.73 0,-5.92 -4.8,-10.73 -10.73,-10.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M79.05 107.26c-8.36,-0.03 -15.12,-6.81 -15.12,-15.18 0,-8.38 6.8,-15.18 15.18,-15.18 8.38,0 15.18,6.8 15.18,15.18 0,0 0,0 0,0 0,8.38 -6.8,15.17 -15.18,15.17 -0.02,0 -0.04,0 -0.05,0l0 0zm0 -25.85c-5.92,-0 -10.72,4.8 -10.72,10.72 0,5.92 4.8,10.73 10.73,10.73 5.92,0 10.73,-4.8 10.73,-10.73 0,-0.07 0,-0.14 0,-0.21 0,-5.92 -4.8,-10.73 -10.73,-10.73 0,0 -0,0 -0,0l-0 0.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M138.04 107.26c-8.36,-0.03 -15.12,-6.81 -15.12,-15.18 0,-8.38 6.8,-15.18 15.18,-15.18 8.38,0 15.18,6.8 15.18,15.18 0,0 0,0 0,0 0,8.38 -6.8,15.17 -15.18,15.17 -0.02,0 -0.04,0 -0.05,0l0 0zm0 -25.85c-5.92,-0 -10.73,4.8 -10.73,10.72 0,5.92 4.8,10.73 10.73,10.73 5.92,0 10.73,-4.8 10.73,-10.73 0,-0.07 0,-0.14 0,-0.21 0,-5.92 -4.8,-10.73 -10.73,-10.73 0,0 -0,0 -0,0l0 0.21z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993512264560"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M32.82 190.86c-8.27,-0.15 -14.91,-6.9 -14.91,-15.18 0,-8.38 6.8,-15.18 15.18,-15.18 8.38,0 15.18,6.79 15.18,15.18 -0.03,8.39 -6.84,15.18 -15.23,15.18 -0.07,0 -0.15,-0 -0.21,-0l-0 0zm0 -25.85c-5.92,-0 -10.72,4.8 -10.72,10.72 0,5.92 4.8,10.73 10.73,10.73 5.92,0 10.73,-4.8 10.73,-10.73 0,-5.92 -4.8,-10.73 -10.73,-10.73l-0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993512262064"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M187.11 190.86c-8.38,-0 -15.18,-6.8 -15.18,-15.18 0,-8.38 6.8,-15.18 15.18,-15.18 8.38,0 15.18,6.8 15.18,15.18 -0.03,8.37 -6.81,15.15 -15.18,15.18l-0 0zm0 -25.85c-5.92,-0 -10.73,4.8 -10.73,10.72 0,5.92 4.8,10.73 10.73,10.73 5.92,0 10.73,-4.8 10.73,-10.73 0,-5.92 -4.8,-10.73 -10.73,-10.73l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993512262160"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 198.64,
    y: 174.29,
    width: 19.84,
    height: 4.5
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc27);
export default __webpack_public_path__ + "static/media/ic_2_7.ebd397209ff4ba71c90d3f09f54efcc2.svg";
export { ForwardRef as ReactComponent };